// String values are a best guess pending backend confirmation of the exact
// `modules` values returned by GetMyExtendedProfileResponse.
export const sidekickModuleEnum = {
  RADAR: "radar",
  MLS_ACCESS: "mlsAccess",
  CRM: "crm",
} as const;

export type SidekickModuleId =
  (typeof sidekickModuleEnum)[keyof typeof sidekickModuleEnum];
